export const DEVNET_VAULT_PACKAGE_ID = '0xTODO'
export const MAINNET_VAULT_PACKAGE_ID = '0xTODO'
